/* eslint-disable no-console */
import {now} from '../../../utils/datetime';

const isHermesRuntime =
  typeof globalThis === 'object' && 'HermesInternal' in globalThis;

export const logRequest = ({
  isFailed,
  json,
  method,
  options,
  requestTime,
  response,
}: {
  isFailed?: boolean;
  json?: any;
  method: string;
  options: RequestInit;
  requestTime: number;
  response: Response;
}) => {
  if (process.env.NODE_ENV === 'development') {
    let header = `${now()} | ${response.status} | ${requestTime.toFixed(
      1,
    )}ms | ${method}`;

    if (isFailed && json && json.error) {
      header += ` | ${json.error.code}`;
    }

    const logMethod = isFailed ? 'warn' : 'info';

    console[
      // @ts-expect-error: TODO: describy why
      console.groupCollapsed && !isHermesRuntime ? 'groupCollapsed' : logMethod
    ](`%c${header}`, `color: ${isFailed ? 'red' : 'green'};font-weight: 600`);

    if (isHermesRuntime) {
      return;
    }

    console[logMethod]({
      request: options.body ? JSON.parse(options.body as string) : null,
      response: json,
    });

    const requestHeaders: string[] = [];
    const responseHeaders: string[] = [];

    for (const headerName in options.headers) {
      requestHeaders.push(`${headerName}: ${options.headers[headerName]}`);
    }

    response.headers.forEach((value, headerName) => {
      responseHeaders.push(`${headerName}: ${value}`);
    });
    console[logMethod]({
      requestHeaders,
      responseHeaders,
    });

    if (console.groupEnd) {
      console.groupEnd();
    }
  }
};
